// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1KtPR","productName":"Table_productName__1iG-C"};